@let filteredReviews = getFilteredReviews();

@if (!isSmallScreen$()) {
<div class="gallery-container">
  <div class="review-gallery">
    @for (review of filteredReviews(); track $index; let index = $index) {
    @if (index < 3) { <ng-container *ngTemplateOutlet="content; context: { $implicit: review }"></ng-container>
      }
      }
  </div>
</div>
}
@else {
<div class="swiper-container">
  <swiper-container slides-per-view="1.3" initial-slide="1" centered-slides="true" space-between="10" pagination="true"
    auto-height="false">
    @for (review of filteredReviews(); let index = $index; track $index) {
    <swiper-slide class="swiper-slide">
      <ng-container *ngTemplateOutlet="content; context: { $implicit: review }"></ng-container>
    </swiper-slide>
    }
  </swiper-container>
</div>
}
@if (GRLink) {
<div class="inner-container lower-button" (click)="trackReviewClick()">
  <a [href]="GRLink" target="_blank"><button mat-flat-button class="primary-button">Bewerte uns auf
      Google</button></a>
</div>
}


<!-- Template for the reviews -->
<ng-template #content let-review>
  @defer (when ccAccepted$()) {
  <div class="review-container custom-elevation-z4 costum-mat-surface-container-low">
    <div class="review-inner-container">
      <div class="review-container-header">
        <!-- <div class="stars " id="stars5"></div> -->
        <div class="stars-new">
          @for (rating of [].constructor(5); let index = $index; track $index) {
          <mat-icon class="{{ index < review.rating ? 'filled' : 'empty' }}">star</mat-icon>
          }
        </div>
        <p class="custom-body-medium review">{{ review.text }}</p>
      </div>
    </div>

    <div class="profile-container costum-mat-surface-container">
      <div class="profile-photo" id="profile-photo1">
        <img [src]="review.photoUrl" (error)="useDefaultImage($event)" alt="Logo des GSV Wangen">
      </div>
      <div class="profile-details">
        <h2 class="profile-name custom-title-medium">{{review.name}}</h2>
        <p class="profile-description custom-label-medium">{{review.description || 'Glücklicher Teilnehmer'}}</p>
      </div>
    </div>
  </div>
  } @placeholder {
  <div class="custom-title-medium">Lade Bewertungen...</div>
  }
</ng-template>